<template>
    <div>
        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard" :isFinalizado="ocorrencia.flFinalizado" />
        <div class="container-fluid">
            <div class="d-flex">
                <div class="flex-grow-1">
                    <InputSearch v-model="filtro_text" placeholder="Pesquise " @updateSearch="reloadGrid" />
                </div>
                <div class="ms-2">
                    <button class="btn-new-crud new-agendamento float-end" v-on:click="abreModalPreviewAgendamentoCrud">
                        <i class="fas fa-regular fa-plus"></i><span class="ms-2">Adicionar Agendamento</span>
                    </button>
                </div>
            </div>
            <div class="row mt-1" style="padding-left: 13px;padding-right: 13px">
                <DataTable :url_ajax="getUrlAgendamento()" :customHeightPaginate="outDateSizePg" :customHeight="outDateSize"
                    :ajax_set_result="setTable" @grid_refreshed="gridRefreshed" :refresh="refresh_grid" :filtros="filtro"
                    method="GET" :qtd_registros_por_pagina="20" :is_table="true" :footer_fixed="true" :headers="headers"
                    :pBtnsSlot="true" :is_modal="true" :is_NotLoading="NotLoading" :styleBotton="'bottom:-5px;left:0px'" lineHeigthProp="line-height: 25px;" :request_api="'comercial'">
                    <template v-slot:BtnSlot="item">
                        <div class="d-flex" style="justify-content: flex-end;">
                            <div class="d-flex flex-row" v-html="retornaStatusTarefa(item.row.idStatus, item.row.dtInclusaoString)">
                            </div>
                            <button class="btn-grid-editar-lista" @click="OpenEditarTarefa(item.row.idTarefa)">
                                <i class="fas fa-pencil-alt" aria-hidden="true"></i><span class="btn-span-text">Editar</span>
                            </button>
                        </div>
                    </template>
                </DataTable>
            </div>
        </div>

        <modal-warper target="agendamento_crud" :show="isOpenModalAgendaCrud" @close="(isOpenModalAgendaCrud = false)">
            <ModalAgendamentoCrud :idOcorrencia="idOcorrencia" :show="isOpenModalAgendaCrud" @reloadGrid="reloadGrid" />
        </modal-warper>
       
    
    <!-- CRUD EDITAR -->
        <modal-warper target="tarefa_crud" :show="isOpenModalTarefaCrud" @close="(isOpenModalTarefaCrud = false)">
            <Modal id="tarefa_crud" :size="''" :open="isOpenModalTarefaCrud" :customModalBody="'overflow-y: auto !important;'" :customSizeWid="''" :FooterDefault="false" :ClassBG="true" :customModalMain="'z-index:100000'">

                <template v-slot:header>
                    <h6 class="modal-title">
                        Editar Tarefa
                    </h6>
                    <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close" @click="fecharModal()"><i
                            class="fas fa-times btn-close-style-v2 hover-effect"></i></button>
                </template>

                <template v-slot:body>
                    <div class="row m-3">
                        <div class="d-flex">
                            <button style="width: 50%" type="button"
                                :class="tabCadastro == true ? 'btn btn-cad-v2' : 'btn-white-v2'"
                                v-on:click="setTabCadastro">
                                <i class="fa fa-calendar-plus pe-2"></i>
                                Cadastro
                            </button>
                            <button style="width: 50%" type="button"
                                :class="tabHistorico == false ? 'btn btn-his-v2' : 'btn-red-v2'"
                                v-on:click="setTabHistorico">
                                <i class="fas fa-history pe-2"></i>
                                Histórico
                            </button>
                        </div>
                    </div>

                    <div v-if="tabCadastro" class="row">
                        <div class="row d-flex px-4">
                            <div class="mt-3">
                                <label class="form-label">Tipo</label>
                                <vue-select :options="filtro_tipo" v-model="filtro_tipo_selects" :label-by="formatNameTipo"
                                            placeholder="Selecione o Tipo" searchable search-placeholder="Pesquise" close-on-select
                                            clear-on-select :min="1" class="form-control shadow-v2"
                                            :class="{ filled: filtro_tipo_selects }">
                                </vue-select>
                            </div>

                            <div class="mt-3">
                                <label class="form-label">Nome</label>
                                <input name="nmTarefa" label="Nome" type="text" class="form-control shadow-v2"
                                       rules="required" v-model="TarefaCrud.nmTarefa"
                                       :class="{ filled: TarefaCrud.nmTarefa }" />
                            </div>

                            <div class="col s6 mt-3">
                                <label class="form-label">Data</label>
                                <DateInput v-model="TarefaCrud.dtTarefa" dateFormat="DD/MM/YYYY" />
                            </div>

                            <div class="col s6 mt-3">
                                <label class="form-label">Hora</label>
                                <input type="time" class="form-control shadow-v2" v-model="TarefaCrud.hrTarefa"
                                       :class="{ filled: TarefaCrud.hrTarefa }" />
                            </div>

                            <div class="mt-3">
                                <label class="form-label">Descrição</label>
                                <textarea class="form-control shadow-v2" rows="3" v-model="TarefaCrud.dsTarefa"
                                          :class="{ filled: TarefaCrud.dsTarefa }"></textarea>
                            </div>
                        </div>
                    </div>

                    <div v-if="tabHistorico" class="row" style="justify-content: center;">
                        <div class="row tesk">
                            <DataTable :url_ajax="getUrlHistorico()" :ajax_set_result="setHistorico"
                                @grid_refreshed="gridRefreshed1" :refresh="refresh_grid1" :filtros="filtroCrud" method="GET"
                                :qtd_registros_por_pagina="20" :is_table="true" :footer_fixed="true" :headers="headersCrud"
                                :pBtnsSlot="true" request_api="plataforma" :customHeight="innerDataSize"
                                :customHeightPaginate="innerDataSizePg">
                            </DataTable>
                        </div>
                    </div>
                </template>

                <template v-slot:footer>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-close-clean-v2" style="height: 40px" data-bs-dismiss="modal"
                            @click="fecharModal()">
                            Fechar
                        </button>
                        <p v-if="tarefaCancelada" class="text-danger" style="padding-right: 10px; font-weight: 700">
                            Tarefa Cancelada
                        </p>
                        <p v-if="tarefaFinalizada" class="text-success" style="padding-right: 10px; font-weight: 700">
                            Tarefa Finalizada
                        </p>
                        <button v-if="!tarefaFinalizada && !tarefaCancelada" type="button" class="btn btn-white-v2"
                            style="padding: 0 30px 3px 30px !important;" @click="confirmaCancelamentoTarefa">
                            <i class="fas fa-calendar-times pe-2"></i> Cancelar Tarefa
                        </button>
                        <button v-if="!tarefaFinalizada && !tarefaCancelada" type="button" class="btn btn-green-v2"
                            style="padding: 0 30px 3px 30px !important;" @click="confirmaFinalizacaoTarefa">
                            <i class="fa fa-calendar-check pe-2"></i>
                            Finalizar Tarefa
                        </button>
                        <button v-if="!tarefaFinalizada && !tarefaCancelada" type="button" class="btn btn-red-v2"
                            style="padding: 0 30px 3px 30px !important;" @click="confirmaAlteracaoTarefa">
                            <i class="fa fa-save pe-2"></i>
                            Alterar Tarefa
                        </button>
                    </div>
                </template>

            </Modal>
        </modal-warper>

        <modal-warper target="ModalConfirmacao_alterar_Vigência" :show="isOpenModalConfirmacaoAlterarVigencia" @close="(isOpenModalConfirmacaoAlterarVigencia = false)">
            <ModalConfirmacao id="tarefa_crud_finalizar" :title="'Motivo Finalização'" :description="''"
                :red="'Atenção! Informe no campo abaixo o motivo da finalização.'" :haveText="true"
                :action="'Finalizar tarefa'" @actionReturn="finalizaTarefa" :isDelete="false"  :customModalMain="'z-index:100000'" />
        </modal-warper>
        <modal-warper target="ModalConfirmacao_alterar_Vigência" :show="isOpenModalConfirmacaoAlterarVigencia"
            @close="(isOpenModalConfirmacaoAlterarVigencia = false)">
            <ModalConfirmacao id="tarefa_crud_cancelar" :title="'Motivo Cancelamento'" :description="''"
                :red="'Atenção! Informe no campo abaixo o motivo do cancelamento.'" :haveText="true"
                :action="'Cancelar tarefa'" @actionReturn="cancelaTarefa"  :customModalMain="'z-index:100000'" />
        </modal-warper>
        <modal-warper target="ModalConfirmacao_alterar_Vigência" :show="isOpenModalConfirmacaoAlterarVigencia"
            @close="(isOpenModalConfirmacaoAlterarVigencia = false)">
            <ModalConfirmacao id="tarefa_crud_alterar" :title="'Motivo Alteração'" :description="''" :red="'Atenção! Informe no campo abaixo o motivo da alteração nesta agenda.'
                " :action="'Alterar tarefa'" :haveText="true" @actionReturn="alteraTarefa" :isDelete="false"  :customModalMain="'z-index:100000'" />
        </modal-warper>

    </div>
</template>

<script>

    import axios from 'axios';
    import ModalAgendamentoCrud from './../Modais/ModalAgendamento_Crud'
    import DataTable from '@/components/App/Datatable.vue'
    import ModalWarper from '@/components/App/ModalWarper.vue'
    import Modal from '@/components/App/Modal.vue';
    import VueNextSelect from "vue-next-select";
    import "vue-next-select/dist/index.min.css";
    import OcorrenciaInfo from '@/components/Tickets/Ocorrencia/Ocorrencia_Info.vue'
    import InputSearch from '@/components/App/Input_Search.vue'
    import ModalConfirmacao from "@/components/App/ModalConfirmacao.vue";
    import DateInput from "@/components/App/DateInput.vue";
    import moment from "moment";


    export default {
        name: 'Agendamento',
        components: {
            "vue-select": VueNextSelect,
            ModalAgendamentoCrud,
            DataTable,
            ModalWarper,
            OcorrenciaInfo,
            InputSearch,
            ModalConfirmacao,
            Modal,
            DateInput
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                refresh_grid1: false,
                filtroCrud: [
                    { active: true },
                ],

                refresh_grid: false,
                filtro: [
                    { active: true },
                ],
                headers: [
                    { class: 'col-2', name: 'dtInclusaoString', text: 'Data', order: 0 },
                    { class: 'col-2', name: 'dsLoginInclusao', text: 'Consultor', order: 0 },
                    { class: 'col', name: 'nmTarefa', text: 'Nome', order: 0 },
                    { class: 'col-2', name: 'btns', text: '', actions: true }
                ],
                isOpenModalAgendaCrud: false,
                filtro_text: '',
                NotLoading: false,
                idTarefa: 0,
                idTarefaCrud: 0,
                isOpenModalTarefaCrud: false,
                isOpenModalConfirmacaoAlterarVigencia: false,

                tabCadastro: true,
                tabHistorico: false,

                TarefaCrud: {
                    idTarefa: 0,
                    idTarefaTipo: 0,
                    nmTarefa: "",
                    dsTarefa: "",
                    dtTarefa: "",
                    hrTarefa: Date.now(),
                    dtTarefaPrazo: Date.now(),
                    hrTarefaPrazo: Date.now(),
                    flExibiuPush: false,
                    dsLoginResponsavel: "",
                    dtFinalizacao: Date.now(),
                    dsMotivo: "",
                },

                filtro_tipo: [],
                filtro_tipo_selects: [],

                tarefaFinalizada: false,
                tarefaCancelada: false,
                dateToday: false,
                hourToday: false,

                innerDataSize: '',
                innerDataSizePg: '',
                outDateSize: '',
                outDateSizePg: '',

                tarefaMovimento: [],
                ocorrencia: {},

                headersCrud: [
                    { class: "col-2", name: "dtMovimentoString", text: "Data Movimento", order: 0, },
                    { class: "col-2", name: "nmUsuario", text: "Login Movimento", order: 0, },
                    { class: "col-1", name: "dtTarefaString", text: "Data Tarefa", order: 0, },
                    { class: "col-1", name: "hrTarefa", text: "Hora Tarefa", order: 0 },
                    { class: "col-3", name: "nmTipo", text: "Tipo", order: 0 },
                    { class: "col-3", name: "dsMovimento", text: "Motivo", order: 0 },
                ],
            }
        },
        mounted() {

            this.updateSizeDinamic();
            window.addEventListener('resize', this.updateSizeDinamic);
        },
        updated() {
            this.updateSizeDinamic();

        },
        methods: {
            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                })
            },
            retornaStatusTarefa(_idStatus, _dtAgenda) {
                const now = moment();

                if (_idStatus == 3) {
                    return '<small style="min-width: 85px;" class="d-inline-flex m-2 fw-semibold text-success bg-success bg-opacity-10 border border-success border-opacity-10 rounded-2 justify-content-center align-items-center"">Finalizado</small>';
                } else if (_idStatus == 1) {
                    const dtAgendaParsed = moment(_dtAgenda, 'DD/MM/YYYY HH:mm');
                    if (dtAgendaParsed.isSame(now, 'day')) {
                        return '<small style="min-width: 85px;" class="d-inline-flex m-2 fw-semibold text-warning bg-warning bg-opacity-10 border border-success border-opacity-10 rounded-2 justify-content-center align-items-center"">Hoje</small>';
                    } else if (dtAgendaParsed.isBefore(now)) {
                        return '<small style="min-width: 85px;" class="d-inline-flex m-2 fw-semibold text-danger bg-danger bg-opacity-10 border border-success border-opacity-10 rounded-2 justify-content-center align-items-center"">Atrasado</small>';
                    } else {
                        return '<small style="min-width: 85px;" class="d-inline-flex py-1 m-2 fw-semibold text-primary bg-opacity-10 border border-success border-opacity-10 rounded-2 justify-content-center align-items-center"">No Prazo</small>';
                    }
                } else if (_idStatus == null || _idStatus == 2) {
                    return '<small style="min-width: 85px;" class="d-inline-flex py-1 m-2 fw-semibold bg-opacity-10 border border-success border-opacity-10 rounded-2 justify-content-center align-items-center"">Cancelada</small>';
                }
            },
            fecharModal() {
                this.zerarInformacoes();
                this.reloadGrid();

            },
            updateSizeDinamic() {
                //if (window.innerWidth <= 1400) {

                //    this.innerDataSize = 'min-height: calc(100vh - 17rem); max-height: calc(100vh - 17rem);'
                //    this.innerDataSizePg = 'max-height: calc(100vh - 20rem);min-height: calc(100vh - 20rem);'
                //    this.outDateSize = 'min-height: calc(100vh - 22.3rem);margin-top:1px !important; max-height: calc(100vh - 22.3rem);'
                //    this.outDateSizePg = 'max-height: calc(100vh - 26.1rem);min-height: calc(100vh - 26.1rem);margin-top:1px !important;'
                //} else if (window.innerWidth >= 3500) {

                //    this.innerDataSize = ''
                //    this.innerDataSizePg = ''
                //    this.outDateSize = ''
                //    this.outDateSizePg = ''
                //} else {
                //    this.outDateSize = 'min-height: calc(100vh - 22.3rem);margin-top:2px !important; max-height: calc(100vh - 22.3rem);'
                //    this.outDateSizePg = 'max-height: calc(100vh - 26.1rem);min-height: calc(100vh - 26.1rem);margin-top:1px !important;'
                //    this.innerDataSize = 'max-height: calc(100vh - 15.2rem);margin-top: 0px !important;'
                //    this.innerDataSizePg = 'max-height: calc(100vh - 18rem);margin-top: 0px !important;'

                //}
            },
            zerarInformacoes() {
                this.TarefaCrud = {
                    idTarefa: 0,
                    idTarefaTipo: 0,
                    nmTarefa: "",
                    dsTarefa: "",
                    dtTarefa: "",
                    hrTarefa: Date.now(),
                    dtTarefaPrazo: Date.now(),
                    hrTarefaPrazo: Date.now(),
                    flExibiuPush: false,
                    dsLoginResponsavel: "",
                    dtFinalizacao: Date.now(),
                    dsMotivo: "",
                }


            },
            finalizaTarefa(id, val) {
                let $this = this;

                $this.TarefaCrud.dsMotivo = val;
                $this.TarefaCrud.flExibiuPush = false;

                if ($this.TarefaCrud.dsMotivo == "") {
                    $this.$toast.show("alert", "Escreva um motivo...", true);
                    return;
                }

                axios
                    .post(
                        process.env.VUE_APP_ROOT_API_PLATAFORMA + "/Tarefa/PostFinalizarTarefa",
                        $this.TarefaCrud,
                        { headers: $this.$api.getTokenPlataforma() }
                    )
                    .then(function (response) {
                        var myModalEl = document.getElementById("tarefa_crud");
                        var ModalTarefa = window.bootstrap.Modal.getInstance(myModalEl);

                        ModalTarefa.hide();

                        $this.reloadGrid();
                        $this.TarefaCrud.dsMotivo = '';
                    })
                    .catch(function (error) {
                        var msg = "Ocorreu um erro inesperado";
                        if (error.response) {
                            if (error.response.data.erros != "") {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }

                        $this.$toast.show("alert", msg, true);
                    });
            },
            cancelaTarefa(id, val) {
                let $this = this;

                $this.TarefaCrud.dsMotivo = val;
                $this.TarefaCrud.flExibiuPush = false;

                if ($this.TarefaCrud.dsMotivo == "") {
                    $this.$toast.show("alert", "Escreva um motivo...", true);
                    return;
                }

                axios
                    .post(
                        process.env.VUE_APP_ROOT_API_PLATAFORMA + "/Tarefa/PostCancelarTarefa",
                        $this.TarefaCrud,
                        { headers: $this.$api.getTokenPlataforma() }
                    )
                    .then(function (response) {
                        var myModalEl = document.getElementById("tarefa_crud");
                        var ModalTarefa = window.bootstrap.Modal.getInstance(myModalEl);

                        ModalTarefa.hide();

                        $this.reloadGrid();
                        $this.TarefaCrud.dsMotivo = '';

                    })
                    .catch(function (error) {
                        var msg = "Ocorreu um erro inesperado";
                        if (error.response) {
                            if (error.response.data.erros != "") {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }

                        $this.$toast.show("alert", msg, true);
                    });
            },
            alteraTarefa(id, val) {
                let $this = this;

                $this.TarefaCrud.dsMotivo = val;
                $this.TarefaCrud.flExibiuPush = false;

                if ($this.TarefaCrud.dsMotivo == "") {
                    $this.$toast.show("alert", "Escreva um motivo...", true);
                    return;
                }

                axios
                    .post(process.env.VUE_APP_ROOT_API_PLATAFORMA + "/Tarefa/Post", $this.TarefaCrud, {
                        headers: $this.$api.getTokenPlataforma(),
                    })
                    .then(function (response) {
                        var myModalEl = document.getElementById("tarefa_crud");
                        var ModalTarefa = window.bootstrap.Modal.getInstance(myModalEl);

                        ModalTarefa.hide();
                        $this.reloadGrid();
                        $this.tabCadastro = true;
                        $this.tabHistorico = false;

                        $this.TarefaCrud.dsMotivo = '';
                    })
                    .catch(function (error) {
                        var msg = "Ocorreu um erro inesperado";
                        if (error.response) {
                            if (error.response.data.erros != "") {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }

                        $this.$toast.show("alert", msg, true);
                    });
            },
            getTipoTarefa() {
                let $this = this;

                axios
                    .get(process.env.VUE_APP_ROOT_API_PLATAFORMA + "/TarefaTipo/Get", {
                        headers: $this.$api.getTokenPlataforma(),
                        params: "",
                        notLoading: true,
                    })
                    .then((response) => {
                        $this.filtro_tipo = response.data.data;
                    });
            },
            formatNameTipo(tipo) {
                return tipo.nmTipo;
            },
            setTabCadastro() {
                let $this = this;
                $this.tabCadastro = true;
                $this.tabHistorico = false;
            },
            setTabHistorico() {
                let $this = this;
                $this.tabCadastro = false;
                $this.tabHistorico = true;
            },
            get() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_API_PLATAFORMA + "/Tarefa/GetId?id=" + $this.idTarefaCrud,
                    {
                        headers: $this.$api.getTokenPlataforma(),
                        params: "",
                    }
                )
                    .then((response) => {
                        $this.TarefaCrud = response.data.data;
                        $this.tabCadastro = true;
                        $this.tabHistorico = false;

                        setTimeout(() => {
                            $this.getTarefaMovimentoAtual(
                                $this.idTarefaCrud,
                                $this.TarefaCrud.dsLoginResponsavel
                            );
                            $this.filtro_tipo_selects = $this.filtro_tipo.find(function (tipo) {
                                return tipo.idTarefaTipo === $this.TarefaCrud.idTarefaTipo;
                            });
                        }, 200);

                    });
            },
            getTarefaMovimentoAtual(idTarefa, dsLogin) {
                let $this = this;

                axios
                    .get(
                        process.env.VUE_APP_ROOT_API_PLATAFORMA +
                        "/TarefaMovimento/GetMovimentoAtual?idTarefa=" +
                        idTarefa +
                        "&dsLogin=" +
                        dsLogin,
                        {
                            headers: $this.$api.getTokenPlataforma(),
                            params: "",
                        }
                    )
                    .then((response) => {
                        $this.tarefaMovimento = response.data.data;

                        var result = $this.tarefaMovimento;

                        result.forEach((t) => {
                            if (t.idStatus == 3) {
                                $this.tarefaFinalizada = true;
                                $this.tarefaCancelada = false;
                            } else if (t.idStatus == 2) {
                                $this.tarefaCancelada = true;
                                $this.tarefaFinalizada = false;
                            } else {
                                $this.tarefaCancelada = false;
                                $this.tarefaFinalizada = false;
                            }
                        });
                    });
            },
            reloadGrid1() {
                let $this = this;

                $this.refresh_grid = true;
            },
            gridRefreshed1(data_ajax) {
                let $this = this;

                $this.refresh_grid = false;
            },
            getUrlHistorico() {
                let $this = this;
                return (
                    process.env.VUE_APP_ROOT_API_PLATAFORMA +
                    "/TarefaMovimento/Get?" +
                    "idTarefa=" +
                    $this.idTarefaCrud
                );
            },
            setHistorico(result) {
                return result;
            },
            confirmaFinalizacaoTarefa() {
                let $this = this;
                $this.ModalConfirmacaoView = new window.bootstrap.Modal(
                    document.getElementById("ModalConfirmacao_tarefa_crud_finalizar"),
                    {
                        keyboard: false,
                    }
                );
                $this.ModalConfirmacaoView.show();
            },
            confirmaCancelamentoTarefa() {
                let $this = this;
                $this.ModalConfirmacaoView = new window.bootstrap.Modal(
                    document.getElementById("ModalConfirmacao_tarefa_crud_cancelar"),
                    {
                        keyboard: false,
                    }
                );
                $this.ModalConfirmacaoView.show();
            },
            confirmaAlteracaoTarefa() {
                let $this = this;
                $this.ModalConfirmacaoView = new window.bootstrap.Modal(
                    document.getElementById("ModalConfirmacao_tarefa_crud_alterar"),
                    {
                        keyboard: false,
                    }
                );
                $this.ModalConfirmacaoView.show();
            },
            OpenEditarTarefa(idTarefa) {
                this.idTarefaCrud = idTarefa;

                this.get();

                setTimeout(() => {
                    this.isOpenModalTarefaCrud = true;

                }, 200);
            },
            gridRefreshed(data_ajax) {
                let $this = this;

                $this.refresh_grid = false;
                $this.NotLoading = false;
            },
            reloadGrid() {
                let $this = this;

                $this.NotLoading = false;
                $this.refresh_grid = true;
            },
            abreModalPreviewAgendamentoCrud() {

                this.isOpenModalAgendaCrud = true;
            },
            setTable(result) {

                return result;
            },
            getUrlAgendamento() {
                let $this = this;

                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/Agendamento/GetAgendamentoOcorrencia?' + 'idOcorrencia=' + $this.idOcorrencia;
            },
            setActionCard(action) {
                this.$emit('setActionCard', action);
            },
        },
        watch: {
            idOcorrencia(newVal, oldVal) {
                if (newVal) {
                    this.reloadGrid();
                    this.getOcorrencia();
                }

            },
            idTarefaCrud(newVal, oldVal) {
                if (newVal && newVal > 0) {
                    this.getTipoTarefa();
                    this.get();
                }
            },
            filtro_text: function (newVal, oldVal) {
                let $this = this;

                $this.NotLoading = true;
                $this.filtro[0].value = newVal;
                $this.refresh_grid = true;
            },
        },
    }

</script>

<style lang="scss" scoped>
    .bolinhas div {
        width: 20px;
        height: 20px;
        border-radius: 50%;
    }

    .btn-red-v2 {
        border: 1px solid #9F3029;
        border-bottom-left-radius: 0px;
        border-top-left-radius: 0px;
    }

    .btn-cad-v2 {
        border: 1px solid #9F3029;
        border-bottom-right-radius: 0px;
        border-top-right-radius: 0px;
    }

    .btn-white-v2 {
        border-bottom-right-radius: 0px;
        border-top-right-radius: 0px;
    }

    .btn-his-v2 {
        border: 1px solid #9F3029;
        border-bottom-left-radius: 0px;
        border-top-left-radius: 0px;
    }
</style>